import { Link } from "react-router-dom";
import { MessageCircle, Mail, MapPin } from "lucide-react";
import Logo from "@/components/Logo";
import { WEDDING_CITIES } from "@/weddingsConfig";

const WA_LINK = "https://wa.me/905316224378";

const SOON_CITIES = {
  ru: [
    { name: "Анталья", country: "Турция" },
    { name: "Стамбул", country: "Турция" },
    { name: "Алания", country: "Турция" },
    { name: "Дубай", country: "ОАЭ" },
    { name: "Барселона", country: "Испания" },
    { name: "Монако", country: "Монако" },
  ],
  en: [
    { name: "Antalya", country: "Turkey" },
    { name: "Istanbul", country: "Turkey" },
    { name: "Alanya", country: "Turkey" },
    { name: "Dubai", country: "UAE" },
    { name: "Barcelona", country: "Spain" },
    { name: "Monaco", country: "Monaco" },
  ],
  tr: [
    { name: "Antalya", country: "Turkiye" },
    { name: "Istanbul", country: "Turkiye" },
    { name: "Alanya", country: "Turkiye" },
    { name: "Dubai", country: "BAE" },
    { name: "Barcelona", country: "Ispanya" },
    { name: "Monaco", country: "Monako" },
  ],
};

const COPY = {
  ru: {
    tagline: "Свадебная флористика премиум-класса в Турции, Испании, Италии, Греции, ОАЭ и Монако.",
    h_destinations: "Свадебные направления",
    h_services: "Услуги",
    h_company: "Компания",
    h_contacts: "Контакты",
    services: [
      { name: "Магазин букетов", href: (l) => `/${l !== "ru" ? `?lang=${l}` : ""}` },
      { name: "Свадебная флористика", href: (l) => `/weddings${l !== "ru" ? `?lang=${l}` : ""}` },
      { name: "Корпоративы и ивенты", href: null, soon: true },
      { name: "Частные праздники", href: null, soon: true },
    ],
    company: [
      { name: "Блог", href: (l) => `/blog${l !== "ru" ? `?lang=${l}` : ""}` },
      { name: "Политика конфиденциальности", href: (l) => `/legal/privacy${l !== "ru" ? `?lang=${l}` : ""}` },
      { name: "Условия использования", href: (l) => `/legal/terms${l !== "ru" ? `?lang=${l}` : ""}` },
    ],
    soonLabel: "СКОРО",
    rights: "Все права защищены.",
  },
  en: {
    tagline: "Premium wedding floristry in Turkey, Spain, Italy, Greece, the UAE and Monaco.",
    h_destinations: "Wedding destinations",
    h_services: "Services",
    h_company: "Company",
    h_contacts: "Contacts",
    services: [
      { name: "Bouquet shop", href: (l) => `/${l !== "ru" ? `?lang=${l}` : ""}` },
      { name: "Wedding floristry", href: (l) => `/weddings${l !== "ru" ? `?lang=${l}` : ""}` },
      { name: "Corporate & events", href: null, soon: true },
      { name: "Private celebrations", href: null, soon: true },
    ],
    company: [
      { name: "Blog", href: (l) => `/blog${l !== "ru" ? `?lang=${l}` : ""}` },
      { name: "Privacy Policy", href: (l) => `/legal/privacy${l !== "ru" ? `?lang=${l}` : ""}` },
      { name: "Terms of Service", href: (l) => `/legal/terms${l !== "ru" ? `?lang=${l}` : ""}` },
    ],
    soonLabel: "SOON",
    rights: "All rights reserved.",
  },
  tr: {
    tagline: "Turkiye, Ispanya, Italya, Yunanistan, BAE ve Monako'da premium dugun ciceklendirmesi.",
    h_destinations: "Dugun destinasyonlari",
    h_services: "Hizmetler",
    h_company: "Sirket",
    h_contacts: "Iletisim",
    services: [
      { name: "Buket magazasi", href: (l) => `/${l !== "ru" ? `?lang=${l}` : ""}` },
      { name: "Dugun ciceklendirmesi", href: (l) => `/weddings${l !== "ru" ? `?lang=${l}` : ""}` },
      { name: "Kurumsal etkinlikler", href: null, soon: true },
      { name: "Ozel kutlamalar", href: null, soon: true },
    ],
    company: [
      { name: "Blog", href: (l) => `/blog${l !== "ru" ? `?lang=${l}` : ""}` },
      { name: "Gizlilik Politikasi", href: (l) => `/legal/privacy${l !== "ru" ? `?lang=${l}` : ""}` },
      { name: "Kullanim Sartlari", href: (l) => `/legal/terms${l !== "ru" ? `?lang=${l}` : ""}` },
    ],
    soonLabel: "YAKINDA",
    rights: "Tum haklari saklidir.",
  },
};

export default function WeddingsFooterFull({ lang = "ru" }) {
  const t = COPY[lang] || COPY.ru;
  const activeCities = Object.values(WEDDING_CITIES);
  const soon = SOON_CITIES[lang] || SOON_CITIES.ru;

  return (
    <footer className="bg-[#0A0807] text-white" data-testid="weddings-footer-full">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10 py-14 sm:py-20">
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-10 sm:gap-12">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-2">
            <Logo variant="gold" />
            <p className="mt-5 sm:mt-6 text-sm text-white/55 font-light leading-relaxed max-w-sm">{t.tagline}</p>
            <a href={WA_LINK} target="_blank" rel="noopener noreferrer"
               className="mt-7 inline-flex items-center gap-2 sm:gap-3 px-6 py-3 bg-gradient-to-r from-[#FFE5A8] via-[#F5C77A] to-[#E0A954] hover:from-[#FFEDB8] hover:to-[#E8B86C] text-[#0A0807] text-[11px] tracking-[0.22em] font-semibold transition-all rounded-sm shadow-[0_10px_30px_-10px_rgba(245,199,122,0.5)]">
              <MessageCircle className="w-4 h-4" /> WHATSAPP
            </a>
          </div>

          {/* Destinations */}
          <div>
            <h4 className="text-[10px] tracking-[0.3em] text-[#F5C77A] mb-4 sm:mb-5 font-light">{t.h_destinations.toUpperCase()}</h4>
            <ul className="space-y-2.5 text-sm font-light">
              {activeCities.map(c => (
                <li key={c.slug}>
                  <Link to={`/weddings/${c.slug}${lang !== "ru" ? `?lang=${lang}` : ""}`}
                        className="text-white/75 hover:text-[#F5C77A] transition">
                    {lang === "ru" ? c.name : c.nameEn}
                  </Link>
                </li>
              ))}
              {soon.map(c => (
                <li key={c.name} className="text-white/30">
                  {c.name} <span className="text-[9px] tracking-[0.25em] text-[#F5C77A]/45 ml-1.5">{t.soonLabel}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[10px] tracking-[0.3em] text-[#F5C77A] mb-4 sm:mb-5 font-light">{t.h_services.toUpperCase()}</h4>
            <ul className="space-y-2.5 text-sm font-light">
              {t.services.map((s, i) => (
                <li key={i}>
                  {s.href ? (
                    <Link to={s.href(lang)} className="text-white/75 hover:text-[#F5C77A] transition">{s.name}</Link>
                  ) : (
                    <span className="text-white/30">
                      {s.name} {s.soon && <span className="text-[9px] tracking-[0.25em] text-[#F5C77A]/45 ml-1.5">{t.soonLabel}</span>}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Company + Contacts */}
          <div>
            <h4 className="text-[10px] tracking-[0.3em] text-[#F5C77A] mb-4 sm:mb-5 font-light">{t.h_company.toUpperCase()}</h4>
            <ul className="space-y-2.5 text-sm font-light">
              {t.company.map((c, i) => (
                <li key={i}>
                  <Link to={c.href(lang)} className="text-white/75 hover:text-[#F5C77A] transition">{c.name}</Link>
                </li>
              ))}
            </ul>
            <h4 className="text-[10px] tracking-[0.3em] text-[#F5C77A] mt-7 mb-4 font-light">{t.h_contacts.toUpperCase()}</h4>
            <ul className="space-y-2 text-sm font-light">
              <li className="flex items-center gap-2 text-white/75">
                <MessageCircle className="w-3.5 h-3.5 text-[#F5C77A]" />
                <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="hover:text-[#F5C77A] transition">+90 531 622 43 78</a>
              </li>
              <li className="flex items-center gap-2 text-white/75">
                <Mail className="w-3.5 h-3.5 text-[#F5C77A]" />
                <a href="mailto:info@yuccaflower.com" className="hover:text-[#F5C77A] transition">info@yuccaflower.com</a>
              </li>
              <li className="flex items-center gap-2 text-white/55 text-xs">
                <MapPin className="w-3.5 h-3.5 text-[#F5C77A]" />
                {lang === "ru" ? "Бодрум · Ибица · Санторини · Озеро Комо · Дубай · Монако" : "Bodrum · Ibiza · Santorini · Lake Como · Dubai · Monaco"}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 sm:mt-16 pt-6 sm:pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40 font-light">
          <span>&copy; 2026 YUCCA Flowers. {t.rights}</span>
          <span className="text-[10px] tracking-[0.25em]">
            {lang === "ru" ? "С ЛЮБОВЬЮ К НЕВЕСТАМ" : lang === "tr" ? "GELİNLER İÇİN SEVGİYLE" : "MADE WITH LOVE FOR BRIDES"}
          </span>
        </div>
      </div>
    </footer>
  );
}
